/**
 * Idioma activo del shell para toasts / notificaciones.
 * Prioridad: banner (tr-dashboard) → tr-app/Redux → userSession.default_language → localStorage → host.
 */
export function resolveShellDisplayLang(component = null) {
  const norm = (v) => {
    if (v == null || v === '') return '';
    const s = String(v).trim().toLowerCase().slice(0, 2);
    return /^[a-z]{2}$/.test(s) ? s : '';
  };
  try {
    const appEl = document.querySelector('tr-app');
    const dashLang = norm(appEl?.shadowRoot?.querySelector('tr-dashboard')?.lang);
    const appLang = norm(appEl?.lang);
    let usLang = '';
    try {
      const us = JSON.parse(sessionStorage.getItem('userSession') || '{}');
      usLang = norm(us?.default_language);
    } catch {
      /* ignore */
    }
    const lsLang = norm(localStorage.getItem('lang'));
    const compLang = norm(component?.lang);
    return dashLang || appLang || usLang || lsLang || compLang || 'en';
  } catch {
    return norm(component?.lang) || 'en';
  }
}
